import { SeverityTypeEnum } from '../enums/severity-type.enum';

export class LogModel {
  constructor(public readonly severityTypeEnum: SeverityTypeEnum, public readonly message: string, public readonly extra?: any) {
  }
}